module.exports = __webpack_public_path__ + "static-kuaikan-h5-fe/img/error.0d0195d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/native/pay/vip/link_vip_multiple/img/error.png
// module id = Cbqj
// module chunks = 1